import LogRocket from "logrocket";

export function initLogRocket() {
  LogRocket.init("qdbzup/clearerpay");
}
